import React from 'react';
import Panel from './Panel';
import Averbacao from '../../components/Panel/Form/Averbacao';



const AverbacaoPage = () => {

  return (
    <Panel>
      <div>
        <Averbacao />
      </div>
    </Panel>

  );
};

export default AverbacaoPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/AverbacaoPage.js
 **/